import { Grupos } from './../model/grupos.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class GruposService {

  baseUrl = environment.baseUrl;


  constructor(private http: HttpClient) { }

  getAll(params: any, id: any): Observable<any> {
    const url = `${this.baseUrl}grupos/listarTodos/${id}?page=${params.page}`;
    return this.http.get<any>(url)
  }

  listarService(): Observable<Grupos[]> {
    const url = `${this.baseUrl}grupos/listarTodos`;
    return this.http.get<Grupos[]>(url);
  }

  listarServiceGrupos(id: any): Observable<Grupos[]> {
    const url = `${this.baseUrl}grupos/listarTodosGrupos/${id}`;
    let idCliente = new HttpParams().set('cliente', id);
    return this.http.get<Grupos[]>(url)
  }

  listarIdService(id: any): Observable<Grupos> {
    const url = `${this.baseUrl}grupos/${id}`;
    return this.http.get<Grupos>(url);
  }

  cadastrarService(grupo: Grupos): Observable<Grupos> {
    const url = `${this.baseUrl}grupos/cadastro`;
    return this.http.post<Grupos>(url, grupo);
  }

  atualizarService(grupo: Grupos): Observable<Grupos> {
    const url = `${this.baseUrl}grupos/atualizar/${grupo.sr_id}`;
    return this.http.put<Grupos>(url, grupo)
  }

  statusService(grupos: Grupos): Observable<any> {
    var status = new Object();
    status = { 'status': grupos.bl_status }
    const url = `${this.baseUrl}grupos/status/${grupos.sr_id}`;
    return this.http.put<any>(url, status)
  }

  public confirmAlert(grupo: any): void {
    Swal.fire({
      title: 'Desativar grupo?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        grupo.bl_status = 0;
        this.statusService(grupo).subscribe((resp) => { })
      }
    })
  }

  public desativarAlert(grupo: any): void {
    Swal.fire({
      title: 'Ativar grupo?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar!'
    }).then((result) => {
      if (result.isConfirmed) {
        grupo.bl_status = 1;
        this.statusService(grupo).subscribe((resp) => { })
      }
    })
  }
}


